import { render, staticRenderFns } from "./layout-auth.vue?vue&type=template&id=91276fdc&scoped=true"
import script from "./layout-auth.vue?vue&type=script&lang=js"
export * from "./layout-auth.vue?vue&type=script&lang=js"
import style0 from "./layout-auth.vue?vue&type=style&index=0&id=91276fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91276fdc",
  null
  
)

export default component.exports